import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Table from './table';
import { PanelStyled } from '../../../common/configuration';
import SummaryDetails from './summaryDetails';
import PageHeader from '../../../common/detailViews/pageHeader/PageHeader';
import { FORM_CONFIG } from '../../../../data/enums/config';
import withErrorAndLoadingScreen from '../../../../utils/composition/withLoading';
import { PanelCard ,Button } from '../../../../v4/components';
import { title } from './config';

const propTypes = {
  skus: PropTypes.instanceOf(Array),
  data: PropTypes.instanceOf(Object),
  loading: PropTypes.bool,
  vendorList: PropTypes.instanceOf(Array),
  breadCrumb: PropTypes.instanceOf(Array),
  permission: PropTypes.instanceOf(Object),
  handlePrnCancel: PropTypes.func,
  distributorId: PropTypes.number,
  handlePrnSubmit: PropTypes.func,
  distributorList: PropTypes.instanceOf(Array),
  enableErrorDisplay: PropTypes.bool,
  invoiceNumberStatus: PropTypes.bool,
  detailsFormConfig: PropTypes.instanceOf(Object),
  displayAlert: PropTypes.func.isRequired,
  getTableDetails: PropTypes.func.isRequired,
  getSummaryDetails: PropTypes.func.isRequired,
  onInvoiceNumberChange: PropTypes.func.isRequired,
  getTableValidationStatus: PropTypes.func.isRequired,
  getDetailsValidationStatus: PropTypes.func.isRequired,
  subDUser: PropTypes.bool,
  handleValueUpdate: PropTypes.func,
  getSKUBatchDetail: PropTypes.func,
};

const defaultProps = {
  skus: [],
  data: {},
  breadCrumb: [],
  permission: {},
  vendorList: [],
  distributorId: 0,
  distributorList: [],
  detailsFormConfig: {},
  enableErrorDisplay: false,
  handlePrnCancel: () => null,
  handlePrnSubmit: () => null,
  invoiceNumberStatus: false,
  loading: false,
  subDUser: false,
  handleValueUpdate: () => null,
};

const CreatePrnView = ({
  data,
  skus,
  subDUser,
  permission,
  breadCrumb,
  vendorList,
  displayAlert,
  distributorId,
  handlePrnSubmit,
  handlePrnCancel,
  distributorList,
  getTableDetails,
  getSummaryDetails,
  detailsFormConfig,
  enableErrorDisplay,
  invoiceNumberStatus,
  onInvoiceNumberChange,
  loading,
  handleValueUpdate,
  getTableValidationStatus,
  getDetailsValidationStatus,
  getSKUBatchDetail,
}) => (
  <Fragment>
    <div className='section-header'>
      <PanelStyled>
        <div className='prn-page-header'>
          <PageHeader
            breadCrumb={breadCrumb}
            title={title}
          />
          <div className='inventory-submit-btn'>
            <Button
              small
              disabled={loading}
              secondary
              onClick={() => handlePrnCancel()}
            >
              <span>
                Cancel
              </span>
            </Button>
            <Button
              small
              primary
              disabled={loading}
              onClick={() => handlePrnSubmit()}
            >
              <span>
                Save
              </span>
            </Button>
          </div>
        </div>
      </PanelStyled>
    </div>
    <div className='section-content pad-48'>
      <PanelCard cardTitle='detail'>
        <SummaryDetails
          subDUser={subDUser}
          vendorList={vendorList}
          permission={permission}
          getDetails={getSummaryDetails}
          formConfig={detailsFormConfig}
          loading={loading}
          distributorList={distributorList}
          getStatus={getDetailsValidationStatus}
          enableErrorDisplay={enableErrorDisplay}
          invoiceNumberStatus={invoiceNumberStatus}
          handleValueUpdate={handleValueUpdate}
          onInvoiceNumberChange={onInvoiceNumberChange}
          data={detailsFormConfig[FORM_CONFIG.MAPPER](data || {})}
        />
      </PanelCard>

      <PanelCard cardTitle='sku' skuClassStatus>
        <Table
          data={data}
          skuList={skus}
          permission={permission}
          displayAlert={displayAlert}
          getDetails={getTableDetails}
          distributorId={distributorId}
          getStatus={getTableValidationStatus}
          enableErrorDisplay={enableErrorDisplay}
          invoiceNumberStatus={invoiceNumberStatus}
          getSKUBatchDetail={getSKUBatchDetail}
        />
      </PanelCard>
    </div>
  </Fragment>
);

CreatePrnView.propTypes = propTypes;

CreatePrnView.defaultProps = defaultProps;

export default withErrorAndLoadingScreen(CreatePrnView);
